
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/energy",
      function () {
        return require("private-next-pages/solutions/energy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/energy"])
      });
    }
  